export const login = '/auth/login-admin';
export const forgotPassword = '/auth/recover-password';
export const setPassword = '/auth/set-password';
